var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TableHead as MuiTableHead, TableRow as MuiTableRow } from '@mui/material';
import TableExpandableCell from './Table.ExpandableCell';
import { renderHeaderCell } from './utils/renderHeaderCell';
export default function TableHeader(props) {
    var collapsedRows = props.collapsedRows, disabled = props.disabled, toggleRowExpand = props.toggleRowExpand, columns = props.columns, config = props.config, variant = props.variant;
    var isExpandable = variant === 'expandable';
    var isAnyRowCollapsed = Object.values(collapsedRows).some(function (row) { return row; });
    return (_jsx(MuiTableHead, __assign({ datatype: variant }, { children: _jsxs(MuiTableRow, { children: [isExpandable && (_jsx(TableExpandableCell, { disabled: disabled, open: isAnyRowCollapsed, index: "all", onCollapseClick: toggleRowExpand })), columns.map(function (column, index) { return renderHeaderCell({ column: column, variant: variant, index: index, config: config }); })] }) })));
}
